import './Home.css';
import logo from './MoldonLogo.png';
import SERVER_URL from '../../env.js';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthorization } from '../../Utils/AuthUtils.js';

function Home() {
    const navigate = useNavigate();
    const [dbStatus, setDbStatus] = useState(null);

    const { authInfo } = useAuthorization();
    useEffect(() => {
        if (authInfo?.user) {
            navigate('/dashboard');
        }
    }, [authInfo, navigate]);

    useEffect(() => {
        fetch(SERVER_URL + '/db-test')
            .then((res) => res.json())
            .then((data) => setDbStatus(data))
            .catch(() => setDbStatus({ status: 'error' }));
    }, []);

    return (
        <div className="home-container">
            {/* Navigation Bar */}
            <nav className="home-navbar">
                <div className="navbar-brand">
                    <img src={logo} className="navbar-logo" alt="Moldon Logo" />
                    <span className="brand-text">Moldon <span className="brand-accent">Online</span></span>
                </div>
                <div className="navbar-actions">
                    <Link to="/login" className="nav-btn nav-btn--secondary">Login</Link>
                    <Link to="/signup" className="nav-btn nav-btn--primary">Sign Up</Link>
                </div>
            </nav>

            {/* Hero Section */}
            <header className="home-hero">
                <div className="hero-content">
                    <h1 className="hero-title">
                        Your Secure Tax & <br />
                        <span className="text-gradient">Accounting Portal</span>
                    </h1>
                    <p className="hero-subtitle">
                        Access your documents, track returns, and manage client files in one unified, secure platform.
                    </p>
                    <div className="hero-cta">
                        <Link to="/signup" className="cta-btn cta-btn--primary">Get Started</Link>
                        <Link to="/login" className="cta-btn cta-btn--secondary">Sign In</Link>
                    </div>
                </div>
                <div className="hero-glow"></div>
            </header>

            {/* Features Section */}
            <section className="home-features">
                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon">📁</div>
                        <h3 className="feature-title">Secure Document Vault</h3>
                        <p className="feature-desc">
                            Upload and store T4s, T5s, receipts, and tax notices in a secure, encrypted environment.
                        </p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">📊</div>
                        <h3 className="feature-title">Tax Return Tracking</h3>
                        <p className="feature-desc">
                            Monitor the status and progress of tax returns with real-time status updates and downloads.
                        </p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">👥</div>
                        <h3 className="feature-title">Client Management</h3>
                        <p className="feature-desc">
                            Easily manage client details, organize documents, and collaborate seamlessly on tax matters.
                        </p>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="home-footer">
                <div className="footer-status">
                    <span className={`status-indicator ${dbStatus?.status === 'connected' ? 'status--ok' : 'status--error'}`}></span>
                    <span className="status-text">
                        {dbStatus?.status === 'connected' ? 'System Operational' : 'Connecting to Server...'}
                    </span>
                </div>
                <p className="footer-copyright">
                    Copyright &copy; {new Date().getFullYear()} Moldon Accounting Services. All rights reserved.
                </p>
            </footer>
        </div>
    );
}

export default Home;
